import { memo, useMemo } from 'react';
import { Autocomplete } from '@mui/material';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import PmiTextField from 'shell/components/shared/text-field';
import { ItemVM } from 'shell/view-models/item';
import { DocumentRegistry } from 'shell/models/document-registry';

interface RegisterTypeProps {
  disabled?: boolean;
  value: ItemVM | null;
  onChange: (item: ItemVM | null) => void;
  error?: boolean;
  errorMessage?: string;
  id?: string;
  label?: string;
}

const AutocompleteRegistryComponent = ({
  disabled,
  onChange,
  value,
  error,
  errorMessage,
  id,
  label,
}: RegisterTypeProps): React.ReactElement => {
  const [series] = useHttpFetch<HttpResponseList<DocumentRegistry>, Array<ItemVM>>(
    `${__CIVIL_STATUS_API_URL__}/registro-atto`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
      },
      transformer: (response) =>
        (response?.data?.payload?.list || []).map((item) => ({
          id: item.key?.codiceRegistro || '',
          value: item.key?.codiceRegistro || '',
        })),
    }
  );

  const seriesData = (series.data as Array<ItemVM>) || [];

  const handleChange = (element: ItemVM | null): void => {
    onChange(element);
  };

  const defaultProps = useMemo(() => {
    const items = seriesData.slice() || [];

    return {
      options: items,
      getOptionLabel: (option: ItemVM) => option.id?.toString(),
    };
  }, [seriesData]);

  return (
    <Autocomplete
      {...defaultProps}
      value={value}
      id={id}
      noOptionsText="Nessun elemento"
      loadingText="Caricamento..."
      onChange={(event, element) => {
        event.stopPropagation();
        handleChange(element);
      }}
      disabled={disabled}
      clearOnBlur={false}
      renderInput={(params) => (
        <PmiTextField
          {...params}
          label={label}
          variant="outlined"
          error={error}
          helperText={errorMessage}
        />
      )}
    />
  );
};

AutocompleteRegistryComponent.displayName = 'List registry autocomplete component';

const AutocompleteRegistry = memo(AutocompleteRegistryComponent);

export default AutocompleteRegistry as typeof AutocompleteRegistryComponent;
